import { c as _c } from "react/compiler-runtime";
import { FlexColumn, NumberDisplay, TableCell, TableRow, TextBody } from "@opensea/ui-kit";
import { RECEIPT_TABLE_COLUMN_CLASSNAMES } from "./constants";
import { ReceiptRowItemDisplay } from "./ReceiptRowItemDisplay";
export const ReceiptRowDisplay = t0 => {
  const $ = _c(12);
  const {
    item,
    price,
    quantity: t1
  } = t0;
  const quantity = t1 === undefined ? 1 : t1;
  const totalPrice = price ? price.unit * quantity : 0;
  const totalUsd = price ? price.usd * quantity : 0;
  const hasPrice = price && (price.unit > 0 || price.symbol);
  let t2;
  if ($[0] !== item) {
    t2 = <TableCell className={RECEIPT_TABLE_COLUMN_CLASSNAMES.item}><ReceiptRowItemDisplay {...item} /></TableCell>;
    $[0] = item;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== hasPrice || $[3] !== price?.symbol || $[4] !== totalPrice || $[5] !== totalUsd) {
    t3 = hasPrice ? <FlexColumn className="text-right"><TextBody weight="semibold"><NumberDisplay suffix={price?.symbol} value={totalPrice} /></TextBody><TextBody className="font-mono" color="text-secondary"><NumberDisplay display="usd" value={totalUsd} /></TextBody></FlexColumn> : null;
    $[2] = hasPrice;
    $[3] = price?.symbol;
    $[4] = totalPrice;
    $[5] = totalUsd;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <TableCell className={RECEIPT_TABLE_COLUMN_CLASSNAMES.price}>{t3}</TableCell>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <TableRow>{t2}{t4}</TableRow>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};